import { useState } from 'react'

import { useFetch } from '@reveni-io/reveni-ui'

import { websocketActionsWorkspaces } from '@/common/context/websocketActions/constants'
import useWebsocketActions from '@/common/hooks/useWebsocketActions/useWebsocketActions'
import returnsServices from '@/returns/services/services'

import { pendingWebsocketActionTypes } from '../useWebsocketTransactionAction/constants'
import { transformRequestChangeRefundMethod } from './transformers'

const useChangeRefundMethod = ({ returnId, currentRefundMethod, setToastInfo }) => {
  const [showChangeRefundMethodDrawer, setShowChangeRefundMethodDrawer] = useState(false)
  const [refundMethodSelected, setRefundMethodSelected] = useState(currentRefundMethod)

  const { setPendingWebsocketAction } = useWebsocketActions(websocketActionsWorkspaces.transactions)

  const { fetchData: changeRefundMethod, loading: changingRefundMethod } = useFetch(
    returnsServices.changeRefundMethod,
    {
      doInitialRequest: false,
      transformRequest: transformRequestChangeRefundMethod,
    }
  )

  const openChangeRefundMethodDrawer = () => {
    setRefundMethodSelected(currentRefundMethod)
    setShowChangeRefundMethodDrawer(true)
  }

  const closeChangeRefundMethodDrawer = () => {
    setShowChangeRefundMethodDrawer(false)
  }

  const handleChangeRefundMethod = async () => {
    try {
      const response = await changeRefundMethod({ returnId, refund_method: refundMethodSelected })

      setShowChangeRefundMethodDrawer(false)
      setPendingWebsocketAction(pendingWebsocketActionTypes.changeRefundMethod, response)
    } catch (error) {
      setToastInfo({ show: true, message: error.errorMessage, type: 'error' })
    }
  }

  return {
    showChangeRefundMethodDrawer,
    openChangeRefundMethodDrawer,
    closeChangeRefundMethodDrawer,
    refundMethodSelected,
    setRefundMethodSelected,
    handleChangeRefundMethod,
    changingRefundMethod,
  }
}

export default useChangeRefundMethod
